import { useIsMobile } from '@/common/hooks/useIsMobile';
import BannerDesktop from '@/widgets/HomePage/Banner/desktop';
import { BannerMobile } from '@/widgets/HomePage/Banner/mobile';

const Banner = () => {
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile && <BannerMobile />}
      {!isMobile && <BannerDesktop />}
    </>
  );
};

export default Banner;
